import { registerLWPComponent } from "VSS/LWP";
import { HtmlEditor } from "WorkItemTracking/Scripts/Components/HtmlEditor";

registerLWPComponent("wit-html-editor-legacy-platform", HtmlEditor);
